import { render } from "./TechnologiesSection.vue?vue&type=template&id=c8a5c9b2"
import script from "./TechnologiesSection.vue?vue&type=script&lang=js"
export * from "./TechnologiesSection.vue?vue&type=script&lang=js"

import "./TechnologiesSection.vue?vue&type=style&index=0&id=c8a5c9b2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__